export const translation = {
    noAccess: {
        title: 'common.LiveChat.Transition.Header',
        description: 'common.LiveChat.Transition.Description',
        upgrade: 'common.LiveChat.Transition.Button',
        cancel: 'common.LiveChat.Transition.Link',
    },
    activator: {
        text: 'common.LiveChat.OnlineStatus',
    },
};
